import React from 'react'

import { Card, LineItem } from '@/components'
import { RentalApplication } from '@/types/RentalApplication'

import { pet1Data, pet2Data } from './MoveIn.data'

export function PetsSection({ rentalApplication }: { rentalApplication: RentalApplication }) {
  return (
    <>
      {rentalApplication.hasPets && (
        <>
          {rentalApplication.pet1Type && rentalApplication.pet1Type.length > 0 && (
            <Card cardClassName="mb-4" headerText="Pet 1" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {pet1Data.map(({ label, field, tag }, index) => {
                  return (
                    <LineItem
                      key={index}
                      label={label}
                      last={index === pet1Data.length - 1}
                      tag={tag}
                      value={rentalApplication[field]}
                    />
                  )
                })}
              </div>
            </Card>
          )}
          {rentalApplication.pet2Type && rentalApplication.pet2Type?.length > 0 && (
            <Card cardClassName="mb-4" headerText="Pet 2" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {pet2Data.map(({ label, field, tag }, index) => {
                  return (
                    <LineItem
                      key={index}
                      label={label}
                      last={index === pet2Data.length - 1}
                      tag={tag}
                      value={rentalApplication[field]}
                    />
                  )
                })}
              </div>
            </Card>
          )}
        </>
      )}
    </>
  )
}
